import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { Flame, TrendDown, Trophy } from "@phosphor-icons/react";

const ICONS = { Flame, TrendDown };

export default function BrotherhoodWall() {
  const [wins, setWins] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await http.get("/community/recent-wins?limit=6");
        setWins(data?.wins || []);
      } catch {
        setWins([]);
      } finally {
        setLoaded(true);
      }
    })();
  }, []);

  if (!loaded || wins.length === 0) return null;

  return (
    <div className="id-card" data-testid="brotherhood-wall">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Trophy size={16} weight="bold" className="text-[#FF3333]" />
          <div className="id-label">Brotherhood wins</div>
        </div>
        <div className="text-[10px] text-zinc-500 font-manrope uppercase tracking-[0.15em]">
          You&apos;re not alone in this
        </div>
      </div>

      <div className="space-y-2">
        {wins.map((w, i) => {
          const Icon = ICONS[w.icon] || Trophy;
          return (
            <div key={i} className="flex items-center gap-3 border border-[#262626] bg-[#0F0F0F] px-3 py-2.5" data-testid={`win-${i}`}>
              <div className="w-9 h-9 rounded-full bg-[#FF3333] flex items-center justify-center shrink-0">
                <span className="font-oswald text-xs font-bold text-white">{w.initials}</span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm text-zinc-200 font-manrope leading-tight">
                  <span className="font-bold text-white">{w.initials}</span> {w.label}
                </div>
                {w.date && (
                  <div className="text-[10px] text-zinc-600 uppercase tracking-[0.15em] mt-0.5">
                    {new Date(w.date).toLocaleDateString(undefined, { day: "numeric", month: "short" })}
                  </div>
                )}
              </div>
              <Icon size={20} weight="bold" className="text-[#FF3333] shrink-0" />
            </div>
          );
        })}
      </div>
    </div>
  );
}
